import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const FeesManagement = () => {
  const navigate = useNavigate();
  const [selectedClass, setSelectedClass] = useState('All');
  const [selectedYear, setSelectedYear] = useState('2025-2026');

  // Sample data for fees chart (you can replace with dynamic data)
  const chartData = {
    labels: ['Paid Fees', 'Remaining Fees'],
    datasets: [
      {
        label: 'Fees',
        data: [35000, 15000], // Example: 35k paid, 15k remaining
        backgroundColor: ['#34D399', '#F87171'],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { color: '#374151' },
      },
    },
  };

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold text-center">Fees Management</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Set Class Fees Box */}
        <div
          className="bg-blue-600 text-white rounded-2xl p-8 flex flex-col items-center justify-center cursor-pointer hover:bg-blue-700"
          onClick={() => navigate('/dashboard/admin/fees-management/set-class-fees')}
        >
          <h2 className="text-2xl font-semibold mb-2">Class Fees</h2>
          <p className="text-center">Configure default fees for each class</p>
        </div>

        {/* Student Fees Box */}
        <div
          className="bg-green-600 text-white rounded-2xl p-8 flex flex-col items-center justify-center cursor-pointer hover:bg-green-700"
          onClick={() => navigate('/dashboard/admin/fees-management/student-fees')}
        >
          <h2 className="text-2xl font-semibold mb-2">Student Fees</h2>
          <p className="text-center">Manage individual student fees and installments</p>
        </div>
      </div>

      {/* Graphical Fees Representation with Filters */}
      <div className="bg-white rounded-2xl shadow p-6 mt-10">
        <h2 className="text-2xl font-semibold text-center mb-4">Fees Collection Overview</h2>

        <div className="flex justify-center gap-4 mb-6">
          <select
            className="border rounded-lg px-3 py-2"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
            <option value="All">All Classes</option>
            <option value="3">Class 3</option>
            <option value="4">Class 4</option>
            <option value="5">Class 5</option>
            <option value="6">Class 6</option>
            <option value="7">Class 7</option>
            <option value="8">Class 8</option>
            <option value="9">Class 9</option>
            <option value="10">Class 10</option>
          </select>

          <select
            className="border rounded-lg px-3 py-2"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="2024-2025">2024-2025</option>
            <option value="2025-2026">2025-2026</option>
            <option value="2026-2027">2026-2027</option>
          </select>
        </div>

        <div className="max-w-xs mx-auto">
          <Doughnut data={chartData} options={chartOptions} />
        </div>
      </div>
    </div>
  );
};

export default FeesManagement;